/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */
import * as userApi from "js/api/user";
import { setQueryString } from "js/libs/utils";
import { config } from "config";
import "./utils-announcement";

function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  const nick = userInfo.nickname;
  let nickLogin = userInfo.login;
  const nickMiddle = nickLogin.length / 2;
  const isEven = nickLogin.length % 2 === 0;
  const nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  userApi.aesEncry(userInfo.uid).then((r) => {
    let uid = r.data;
    const isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    const args = {
      customField7: uid,
    };
    const prms = {
      uid,
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack,
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  const $suspension = $(".affix");
  const $backTop = $(".affix-bottom");
  const $panelSuggest = $(".affix-panel-content__suggest");
  const $panelApplet = $(".affix-panel-content__applet");
  const $panelAdvice = $(".affix-panel-content__advice");
  const $iframe = $(".affix-panel-content__iframe");
  let timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    userApi.getUserinfo().then(res => {
      if (res.code === 80000) {
        const jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = `${config.PASSPORT_NEW}/login?jump=${jumpBack}`;
      }else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*')
      }
    })
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(() => {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(() => {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    userApi.getUserinfo().then((result) => {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          const jumpBack = typeof window !== "undefined" ? Base64.encode(setQueryString("isZc", 1)) : "";
          window.location.href = `${config.PASSPORT}/login?jump=${jumpBack}`;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
}
$(function() {
  window.addEventListener("message", function(e) {
    if(e.data.type === 'dom') {
      const { data } = e.data
      const width = data.width
      const height = data.height + 12
      methods.setIframe(width, height)
    }
    if(e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show')
    }
  });
})
export { suspension };



// WEBPACK FOOTER //
// ./src/js/libs/utils-suspension.js